export default __webpack_public_path__ + "static/media/avatar-sticker_club_bot.1ed2d50c.png";